<script setup lang="ts">
import TextComponent from "@/builder/components/text/TextComponent.vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { ref, watch } from "vue";
import { handleMergeTags } from "../../BuilderUtilities";

const props = defineProps(["component"]);

const renderStore = useRenderStore();

const text = ref(handleMergeTags(props.component.customData.value) ?? "");

//watch for net amount changes in renderStore
watch(() => renderStore.netAmount, (newVal, oldVal) => {
    text.value = handleMergeTags(props.component.customData.value) ?? "";
}), { immediate: true, deep: true };

//watch cover gift changes in renderStore
watch(() => renderStore.gift, (newVal, oldVal) => {
    text.value = handleMergeTags(props.component.customData.value) ?? "";
}, { immediate: true, deep: true })

//watch for donor changes in renderStore
watch(() => renderStore.donor, (newVal, oldVal) => {
    text.value = handleMergeTags(props.component.customData.value) ?? "";
}, { immediate: true, deep: true });
</script>

<template>
    <text-component :text="text" :component="component" />
</template>
